const DefaultToObject = function () {
  return {}
}

export default DefaultToObject
